//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import nieuwsberichten from '~/graphql/queries/nieuwsberichten.gql';

export default {
  auth: false,
  apollo: {
    nieuwsBerichten: {
      query: nieuwsberichten,
      variables() {
        return {
          limit: 12,
          page: this.requested_page,
        };
      },
    },
  },
  data: () => ({
    nieuwsBerichten: {
      data: [],
      total: 0,
      per_page: 12,
      current_page: 1,
    },
    requested_page: 1,
  }),
  computed: {
    totalPages() {
      return Math.ceil(this.nieuwsBerichten.total / this.nieuwsBerichten.per_page);
    },
  },
  watch: {
    requested_page() {
      this.$apollo.queries.nieuwsBerichten.refresh();
    },
  },
  head: () => ({
    title: 'Nieuws',
  }),
};
